<div class="pet-list-container">
  <cpf-pet-card-list [showButton]="true" [showFlippedCards]="true" [allowMultipleSelect]="false"
                     [showBuyInsuranceCard]="true" [allPets]="pets"
                     (onCardSelect)="onCardSelectionChange($event)"
                     (onCardActionButtonClick)="navigatePetFnol()"
  ></cpf-pet-card-list>
</div>

<div class="info-container">
  <div class="insurance home-item">
    <div class="title">
      <h4>{{'desktop-home.insurance-details' | translate }}</h4>
      <mat-icon svgIcon="expand-up" [class.collapsed]="topComponentCollapsed" (click)="toggleTopComponentCollapsed()"></mat-icon>
    </div>

    <div class="component" [class.collapsed]="topComponentCollapsed">
      <cpf-insurance-overview
        [orientation]="'horizontal'"
        [desktopVersion]="true"
        (editInsuranceInfoClicked)="navigateEditInsuranceInfo()"
        (editPetInfoClicked)="navigateEditPetInfo()"
        (openDetailsClicked)="navigateInsuranceDetails()"
      ></cpf-insurance-overview>
    </div>
  </div>

  <div class="bottom-part">
    <div class="part bottom-part-left home-item">
      <div class="title">
        <h4>{{'desktop-home.invoices' | translate }}</h4>
      </div>

      <div class="component">
        <cpf-invoice-list (invoiceClicked)="navigateInvoiceDetails($event.invoiceNumber)"></cpf-invoice-list>
      </div>
    </div>
    <div class="part bottom-part-right home-item">
      <div class="title">
        <h4>{{'desktop-home.claims' | translate }}</h4>
      </div>

      <div class="component">
        <cpf-claims-list
          (claimClicked)="navigateClaimDetails($event.identifier)"
          (fnolDetailsClicked)="navigateFnolDetails($event.id)"
        ></cpf-claims-list>
      </div>
    </div>
  </div>
</div>

<!--this need for render subcomponent in modal window and support navigation for that-->
<router-outlet></router-outlet>
